import { render } from "./EconRevTemplate.vue?vue&type=template&id=41bffec2&scoped=true&ts=true"
import script from "./EconRevTemplate.vue?vue&type=script&lang=ts"
export * from "./EconRevTemplate.vue?vue&type=script&lang=ts"

import "./EconRevTemplate.vue?vue&type=style&index=0&id=41bffec2&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bffec2"]])

export default __exports__